// extracted by mini-css-extract-plugin
var _1 = "ListItem-modulelistItem__N9IG9 Tag-moduleTag__FLr9H";
export { _1 as "listItem" }
